import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const Toggle: FC<{
  checked: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
}> = ({checked, onChange, label, disabled = false}) => {
  return (
    <label
      className={clsxm("relative mt-1 inline-flex cursor-pointer items-center", {
        "cursor-not-allowed": disabled,
      })}>
      <input
        type="checkbox"
        value=""
        className="peer sr-only"
        checked={checked}
        onChange={e => onChange && !disabled && onChange(e.target.checked)}
      />
      <div
        className={clsxm(
          "peer border-primary-light-solid bg-primary-powder peer-checked:bg-primary-dark-solid after:border-primary-medium-solid peer-checked:after:border-primary-sky after:bg-primary-medium-solid h-6 w-12 rounded-full border peer-checked:border-none peer-focus:ring-2 peer-focus:ring-blue-300 peer-focus:outline-hidden after:absolute after:top-0.5 after:left-0.5 after:size-5 after:rounded-full after:border after:shadow-sm after:transition-all after:content-[''] peer-checked:after:left-1.5 peer-checked:after:translate-x-full peer-checked:after:bg-white",
          disabled &&
            "border-neutral-grey-light peer-checked:bg-primary-sky after:bg-neutral-grey-light bg-neutral-grey-lightest after:border-neutral-grey-light peer-checked:after:border-primary-sky peer-checked:after:border",
        )}
      />
      {label && <span className="text-neutral-black ml-3 text-sm font-medium">{label}</span>}
    </label>
  );
};

export default Toggle;
